module.exports = __webpack_public_path__ + "img/pick-up2.addc36fe.jpg";